import type { Signal, SignalType } from '@/gen/inventory/v1/signal_pb'

import { useQuickFilterHighlights } from '@/lib/ui/quick-filter-highlights.hook'

import { EmptyCellValue } from '@/components/ag-cells/empty-cell-value'
import { TitleSubtitleCell } from '@/components/ag-cells/title-subtitle-cell/title-subtitle-cell'
import { AIGovernanceIcon } from '@/components/shared/ai-governance-icon/ai-governance-icon'
import { SignalBadges } from '@/components/signal-indicators/signal-indicators'

import { alertNameParts } from './column'

type AlertNameCellProps = {
  signal?: Signal
  titleByType: ReadonlyMap<SignalType, string>
  subtitleClassName?: string
}

export const AlertNameCell = ({ signal, titleByType, subtitleClassName }: AlertNameCellProps) => {
  const { getHighlights } = useQuickFilterHighlights()

  if (!signal) {
    return <EmptyCellValue />
  }

  const { title, description } = alertNameParts(signal, titleByType)
  return (
    <TitleSubtitleCell
      title={title}
      subtitle={description}
      titleHighlights={getHighlights(title)}
      subtitleHighlights={getHighlights(description)}
      subtitleClassName={subtitleClassName}
      titleSuffix={
        <>
          <SignalBadges signal={signal} />
          {signal.isAiGovernance && <AIGovernanceIcon />}
        </>
      }
    />
  )
}
